import React, { useState, useContext } from "react";
import "./regform.css";
import axios from "axios";
import { useSnackbar } from "notistack";
import { ContextGlobal } from "../../context";
import { useHistory } from "react-router-dom";
import { config } from "../../config";

const Doctor = (props) => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { data, setData } = useContext(ContextGlobal);
  const [fields, setFields] = useState(
    !props.updateProfile
      ? {
          uid: props.uid,
          name: "",
          dob: "",
          gender: "",
          email: "",
          contact: props.phno,
          address: "",
          city: "",
          pincode: "",
          state: "",
          type: "doctor",
          doctorReg: "",
          qualification: "",
          experience: "",
        }
      : {
          uid: data.data.uid,
          name: data.data.name,
          dob: data.data.dob,
          gender: data.data.gender,
          email: data.data.email,
          contact: data.data.contact,
          address: data.data.address,
          city: data.data.city,
          pincode: data.data.pincode,
          state: data.data.state,
          type: data.data.type,
          doctorReg: data.data.doctorReg,
          qualification: data.data.qualification,
          experience: data.data.experience,
        }
  );

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFields((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const updateFields = (e) => {
    e.preventDefault();

    console.log(fields);
    axios
      .post(`${config.url.BACKEND}/updateUser`, fields)
      .then((res) => {
        // console.log(res); //console
        setData(res.data);
        enqueueSnackbar("Successfully updated!", { variant: "success" });
        history.push("/dashboard/profile/settings");
      })
      .catch((error) => {
        enqueueSnackbar(error, { variant: "error" });
        console.log(error);
      });
  };

  const postFields = (e) => {
    e.preventDefault();

    axios
      .post(`${config.url.BACKEND}/createUser`, fields)
      .then((res) => {
        // console.log(res); //console
        enqueueSnackbar("Successfully updated!", { variant: "success" });
        window.location.replace("/dashboard");
      })
      .catch((error) => {
        enqueueSnackbar(error, { variant: "error" });
        console.log(error);
      });
  };

  return (
    <form
      className={!props.updateProfile ? "user" : "user1"}
      onSubmit={!props.updateProfile ? postFields : updateFields}
    >
      <div className="regform">
        {!props.updateProfile ? (
          <>
            <h1>Doctor</h1>
            <p>Please fill in this form to create an account.</p>
            <hr />
          </>
        ) : (
          ""
        )}

        <label for="name">
          <b>Name</b>
        </label>
        <input
          type="text"
          placeholder="Enter Name"
          id="name"
          value={fields.name}
          onChange={handleChange}
          required
        />

        <label for="dob">
          <b>Date Of Birth</b>
        </label>
        <input
          type="date"
          id="dob"
          value={fields.dob}
          onChange={handleChange}
          required
        />

        <label for="gender">
          <b>Gender</b>
        </label>
        <div className="radio">
          <span>
            <input
              type="radio"
              value="male"
              name="gender"
              id="gender"
              onClick={handleChange}
              checked={fields.gender === "male" ? true : false}
              required
            />
            &nbsp;Male
          </span>
          <span>
            <input
              type="radio"
              value="female"
              name="gender"
              id="gender"
              onClick={handleChange}
              checked={fields.gender === "female" ? true : false}
              required
            />
            &nbsp;Female
          </span>
          <span>
            <input
              type="radio"
              value="other"
              name="gender"
              id="gender"
              onClick={handleChange}
              checked={fields.gender === "other" ? true : false}
              required
            />
            &nbsp;Other
          </span>
        </div>

        <label for="email">
          <b>Email</b>
        </label>
        <input
          type="email"
          placeholder="Enter Email"
          id="email"
          value={fields.email}
          onChange={handleChange}
          required
        />

        <label for="contact">
          <b>Contact</b>
        </label>
        <input type="text" value={fields.contact} id="contact" readOnly />

        <label for="address">
          <b>Address</b>
        </label>
        <input
          type="text"
          placeholder="Enter Street,Area"
          id="address"
          value={fields.address}
          onChange={handleChange}
          required
        />

        <label for="city">
          <b>City</b>
        </label>
        <input
          type="text"
          placeholder="Enter City"
          id="city"
          value={fields.city}
          onChange={handleChange}
          required
        />

        <label for="pincode">
          <b>Pincode</b>
        </label>
        <input
          type="number"
          placeholder="Enter Pincode"
          id="pincode"
          value={fields.pincode}
          onChange={handleChange}
          required
        />

        <label for="state">
          <b>State</b>
        </label>
        <input
          type="text"
          placeholder="Enter State"
          id="state"
          value={fields.state}
          onChange={handleChange}
          required
        />

        <label for="doctorReg">
          <b>Register Number</b>
        </label>
        <input
          type="text"
          placeholder="Enter Register Number"
          id="doctorReg"
          value={fields.doctorReg}
          onChange={handleChange}
          required
        />

        <label for="qualification">
          <b>Qualification</b>
        </label>
        <input
          type="text"
          placeholder="Enter Qualification"
          id="qualification"
          value={fields.qualification}
          onChange={handleChange}
          required
        />

        <label for="experience">
          <b>Experience</b>
        </label>
        <input
          type="text"
          placeholder="Enter Experience Of Years"
          id="experience"
          value={fields.experience}
          onChange={handleChange}
          required
        />

        <hr />
        <div className="submitConatiner">
          <button type="submit" className="submitConatiner__btn">
            {!props.updateProfile ? "Submit" : "Update"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default Doctor;
